interface FeaturesProps {
  onTryFreeClick?: () => void;
}

export function Features({ onTryFreeClick }: FeaturesProps) {
  return (
    <section className="flex flex-col items-center justify-center gap-8 px-4 py-8 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="flex max-w-2xl flex-col items-center gap-3 text-center">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
          Everything you need to create{" "}
          <span className="text-orange-500">
            captivating shorts faster.
          </span>
        </h1>
        <p className="text-base text-muted-foreground">
          Your all-in-one platform to effortlessly create captivating shorts
          that drive conversions.
        </p>
        <button
          onClick={onTryFreeClick}
          className="mt-2 rounded-lg bg-orange-500 px-5 py-2 text-sm font-semibold hover:bg-orange-600 text-white"
        >
          Create Free Shorts
        </button>
      </div>

      {/* Features Grid */}
      <div className="grid w-[70%] max-w-6xl gap-6 md:grid-cols-2">
        {/* Feature 1 */}
        <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-[#f9fafb] p-6">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold">
              AI-Powered Captions
            </h2>
            <p className="text-sm text-muted-foreground">
              Beautiful AI-powered captions in 48 languages make your videos
              accessible to everyone, even with the sound off. Increase engagement by 40%.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="/images/feature-captions.png"
              alt="AI captions interface"
              width={300}
              height={300}
              className="rounded-lg"
            />
          </div>
        </div>

        {/* Feature 2 */}
        <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-[#f9fafb] p-6">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold">
              Auto B-Roll Footage
            </h2>
            <p className="text-sm text-muted-foreground">
              Transform your videos with AI-generated B-Roll footage that amplifies your message and keeps your audience engaged throughout.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="https://cdn.prod.website-files.com/6469e2294ac68c3d5caea327/67376df5f8e8852b269a9eeb_Feature_2_img_v2.webp"
              alt="B-Roll footage editor"
              width={300}
              height={300}
              className="rounded-lg"
            />
          </div>
        </div>
      </div>
      {/* Feature middle */}
      {/* <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-[#f9fafb] p-6 w-[70%] max-w-6xl">
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-bold">
            Smart Video Trimming
          </h2>
          <p className="text-sm text-muted-foreground">
            Automatically find the best moments in your videos and create engaging short-form clips. Save hours of manual editing work.
          </p>
        </div>
        <div className="flex justify-center">
          <img
            src="https://cdn.prod.website-files.com/6469e2294ac68c3d5caea327/676fda0f01045b5f5f7bd411_Feature_3_img_v7.webp"
            alt="Video trimming interface"
            width={700}
            height={300}
            className="rounded-lg"
          />
        </div>
      </div> */}
      {/* Features Grid */}
      <div className="grid w-[70%] max-w-6xl gap-6 md:grid-cols-2">
        {/* Feature 3 */}
        {/* <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-[#f9fafb] p-6">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold">
              Hook Detection
            </h2>
            <p className="text-sm text-muted-foreground">
              AI automatically detects and highlights your best moments to create hooks that stop the scroll and boost retention.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="https://cdn.prod.website-files.com/6469e2294ac68c3d5caea327/67333f4e9629993302c3301b_Feature_4_img.webp"
              alt="Hook detection feature"
              width={300}
              height={300}
              className="rounded-lg"
            />
          </div>
        </div> */}

        {/* Feature 4 */}
        <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-[#f9fafb] p-6">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold">
              Engagement Optimization
            </h2>
            <p className="text-sm text-muted-foreground">
              AI optimizes your video pacing, transitions, and effects to maximize viewer retention and engagement rates.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="/images/feature-engagement.png"
              alt="Engagement optimization"
              width={300}
              height={300}
              className="rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

